<template>
  <ChartContainer :title="title">
    <BaseChart
      :options="options"
      :width="width"
      :height="height"
    />
  </ChartContainer>
</template>

<script>
import BaseChart from '../base-chart';
import ChartContainer from '../chart-container';

export default {
  props: {
    title: {
      type: String,
      default: '',
    },
    options: {
      type: Object,
      required: true,
    },
    width: {
      type: String,
      default: '100%',
    },
    height: {
      type: String,
      default: '400px',
    },
  },
  components: { BaseChart, ChartContainer },
};
</script>
